<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <title v-if="title">{{ title }}</title>
    <path
      d="M9.967.44c2.7 0 4.988.934 6.828 2.79 1.84 1.857 2.765 4.123 2.765 6.771 0 2.63-.948 4.894-2.83 6.758-1.88 1.863-4.13 2.801-6.722 2.801-2.487 0-4.685-.89-6.567-2.656C1.445 15.033.44 12.701.44 9.943c0-2.716.966-5.01 2.886-6.842C5.174 1.33 7.398.44 9.967.44Zm0 1.12c-2.28 0-4.227.78-5.867 2.35-1.697 1.62-2.54 3.62-2.54 6.033 0 2.45.877 4.485 2.647 6.145 1.677 1.573 3.601 2.352 5.801 2.352 2.294 0 4.261-.82 5.933-2.477 1.67-1.654 2.499-3.631 2.499-5.962 0-2.353-.81-4.336-2.44-5.982-1.628-1.642-3.63-2.459-6.033-2.459Zm.015 4.67c1.057 0 1.965.37 2.691 1.101.722.73 1.089 1.63 1.089 2.667a3.633 3.633 0 0 1-1.116 2.666c-.735.73-1.63 1.102-2.649 1.102-.98 0-1.85-.353-2.587-1.044-.785-.736-1.184-1.662-1.184-2.744 0-1.067.385-1.979 1.135-2.694a3.67 3.67 0 0 1 2.403-1.05l.218-.004Zm-.008 1.12a2.555 2.555 0 0 0-1.834.738c-.533.51-.794 1.127-.794 1.89 0 .773.272 1.403.83 1.928.531.498 1.13.74 1.821.74.722 0 1.334-.255 1.86-.778a2.516 2.516 0 0 0 .785-1.87c0-.744-.251-1.36-.764-1.878a2.514 2.514 0 0 0-1.692-.764l-.212-.006Z"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
});
</script>
